import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { Observable, Subscription } from 'rxjs';
import { ApiEndpointsService } from '../core/services/api-endpoints.service';
import { DataService } from '../core/services/data.service';
import { IHttpService } from '../core/services/ihttp.service';
import { PosService } from '../core/services/pos.service';
import { FilterSelection } from '../core/classes/filterSelection';

@Component({
  selector: 'dq-main-pos-panel',
  templateUrl: './main-pos-panel.component.html',
  styleUrls: ['./main-pos-panel.component.scss'],
})
export class MainPosPanelComponent implements OnInit {
  filtersVisible$!: Observable<boolean>;
  visible!: boolean;
  resizeObservable$!: Observable<Event>;
  resizeSubscription$!: Subscription;
  classSidebar: string = '';
  classMain: string = '';

  mapUp$!: Observable<boolean>;
  classMap: string = '';

  private isLoaded = false;

  @ViewChild('sidebarMenu')
  sidebarMenu!: ElementRef;
  @ViewChild('main')
  main!: ElementRef;

  constructor(
    private dataService: DataService,
    private posService: PosService,
    private apiEndpointsService: ApiEndpointsService,
    @Inject('HttpService') private httpService: IHttpService
  ) {}

  ngOnInit(): void {

    this.isLoaded = this.dataService.getIsLoaded();

    this.dataService.getUserInfo$().subscribe((userInfo) => {
      if (userInfo != null && !this.isLoaded) {
        this.posService.iniPos();
        this.dataService.setIsLoaded(true);
      }
    });

    //ocultar filtros al redimensionar
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
      if (this.visible) {
        this.dataService.sendShowHideFilters();
      }
    });

    // cambiar clases de main y filtros segun si son visibles y el breakpoint
    this.filtersVisible$ = this.dataService.getFiltersVisible$();
    this.filtersVisible$.subscribe((visible) => {
      this.visible = visible;
      if (visible) {
        if (window.innerWidth > 767) {
          this.openNav();
        } else {
          this.openNavMobile();
        }
      } else {
        this.closeNav();
      }
    });

    //posicion del mapa
    this.mapUp$ = this.dataService.getMapUp$();
    this.mapUp$.subscribe((mapUp) => {
      if (mapUp) {
        this.classMap = 'flex-column';
      } else {
        this.classMap = 'flex-column-reverse';
      }
    });
  }

  applyServerFilter($event: any) {
    //console.log('----- onChangeFilter');
    //console.log($event);
    this.posService.applyServerFilter($event);
  }

  openNav() {
    this.classSidebar = 'show navDesktopVisible';
    this.classMain = 'mainDesktopVisible';
  }

  closeNav() {
    this.classSidebar = 'collapse navHidden';
    this.classMain = 'mainHidden';
  }

  openNavMobile() {
    this.classSidebar = 'show navMobileVisible';
    this.classMain = 'mainMobileVisible';
  }
}
